export default {
	colors: {
		color1: '#009ab8',
		color2: '#534fa1',
		textColor: '#009ab8'
	},
	docs: [
		{
			id: 1,
			title: 'Access IDSI Processes and Standards Here',
			link: 'assets/docs/IDSI-Proccesses-and-Standards.pdf'
		}
	],
	didYouKnow: [
		{
			id: 1,
			icon: 'girlBoss',
			title: 'Girl Boss',
			text: 'Did you know that IDSI is a woman-owned, small business?'
		},
		{
			id: 2,
			icon: 'vr',
			title: 'Virtual Reality',
			text: 'Did you know that IDSI creates virtual reality products?'
		},
		{
			id: 3,
			icon: 'usa',
			title: 'USA',
			text: 'Did you know IDSI has employees all over the country both as a part of the PSG and other efforts?'
		}
	],
	principles: [
		{
			id: 1,
			title: 'Entrepreneurial',
			content: '<p>IDSI is an entrepreneurial company. Everyone is expected to be an entrepreneur—build business, be creative, be self-starters, and be professionals building our reputation. IDSI strives to minimize the bureaucracy to encourage flexibility and entrepreneurial behavior.</p>'
		},
		{
			id: 2,
			title: 'Highly Qualified Personnel',
			content: '<p>IDSI is made up of the most highly qualified people in the industry—those who are hungry to continue to grow professionally. IDSI works to provide an environment that will foster professional growth, innovation, and creativity, allowing all to realize their full potential.</p>'
		},
		{
			id: 3,
			title: 'Customer-Focused',
			content: '<p>IDSI is customer-focused; we always support our customers and make them heroes. Anticipating our customers\' needs is one of our mantras. We strive to be proactive, not just responsive, and constantly educate our customers so they will allow us to perform better for them through our products and services. We cannot be any better than our customer allows us to be. Customers can always be assured that when we make recommendations it is in their best interest and not because we will profit from those recommendations.</p>'
		},
		{
			id: 4,
			title: 'Proactive',
			content: '<p>At IDSI we treat each other in the company as each other\'s customer. This means we must be responsive and proactive internally, and we must strive to anticipate each other\'s needs as much as possible. Our support and production personnel prosper from a symbiotic relationship in which the success of one ensures the success of the other. The combined success of both teams ensures the long-term growth and success of the company as a whole.</p>'
		},
		{
			id: 5,
			title: 'Communication-Focused',
			content: '<p>Effective and meaningful communications are vital to the success of our business relationships, both internal to the company and external to our customers. Each communication must be carefully weighed and evaluated for the accuracy of the message and the quality of the content. In our conversations, we should always be honest and precise. Our leaders must ensure that their communications are complete and decisive.</p>'
		},
		{
			id: 6,
			title: 'Integrity',
			content: '<p>Honesty and integrity are big deals in IDSI. We are honest brokers.</p>'
		},
		{
			id: 7,
			title: 'Mentorship',
			content: '<p>Mentoring and coaching are key parts of our culture and essential for our continued learning and growth.</p>'
		},
		{
			id: 8,
			title: 'Recognition',
			content: '<p>Bonuses, rewards, and recognition are given for performance and support our culture and values. We are a performance-based company. Bonuses, rewards, and recognition are earned.</p>'
		},
		{
			id: 9,
			title: 'Growth',
			content: '<p>The IDSI leadership team is committed to growing the company and continuously refining our processes and procedures to reinforce our culture and values. Our goal is to maintain agility, ensure people are not overcome with bureaucracy, and guarantee that our customers get the benefit of a creative and responsive environment. It is leadership\'s job to make sure the infrastructure is in place to support our employees and ultimately benefit our customers.</p>'
		}
	],
	leadership: [
		{
			id: 1,
			name: 'Marci Murawski',
			position: 'Chief Executive Officer',
			location: 'Centreville Office'
		},
		{
			id: 2,
			name: 'Tom Allen',
			position: 'President',
			location: 'Centreville Office'
		},
		{
			id: 3,
			name: 'Tom Archibald',
			position: 'Performance Systems Group Director',
			location: 'Newport News Office'
		},
		{
			id: 4,
			name: 'Joe Collins',
			position: 'Vice President of Business Development',
			location: 'Newport News Office'
		},
		{
			id: 5,
			name: 'Emery Wyatt',
			position: 'Future Training Group Director',
			location: 'Suffolk Office'
		},
		{
			id: 6,
			name: 'Ernest DiLeonardo',
			position: 'Global Services Group Director',
			location: ''
		}
	],
	people: [
		{
			id: 7,
			name: 'David Morris',
			position: 'Chief Financial Officer',
			location: 'Centreville Office'
		},
		{
			id: 8,
			name: 'Michael Magill',
			position: 'Information Technologies Director',
			location: 'Centreville Office'
		},
		{
			id: 9,
			name: 'Karen Marrero',
			position: 'Human Resources Director',
			location: 'Centreville Office'
		},
		{
			id: 10,
			name: 'Stasy Jones',
			position: 'Contracts Director',
			location: 'Centreville Office'
		},
		{
			id: 11,
			name: 'Karen Harper',
			position: 'Facility Security Officer',
			location: 'Centreville Office'
		},
		{
			id: 12,
			name: 'JR Kirchner',
			position: 'Business Operations Specialist',
			location: 'Centreville Office'
		},
		{
			id: 13,
			name: 'Peggy Myatt',
			position: 'Recruiter',
			location: 'Newport News Office'
		}
	],
	locations: [
		{
			id: 1,
			title: 'Centreville, VA',
			address: '5885 Trinity Parkway, Suite 100',
			city: 'Centreville',
			state: 'VA',
			zip: '20120',
			phone: '(703) 766-9631'
		},
		{
			id: 2,
			title: 'Newport News, VA',
			address: '733 Thimble Shoals Boulevard, Suite 100',
			city: 'Newport News',
			state: 'VA',
			zip: '23606',
			phone: '(757) 645-2531'
		},
		{
			id: 3,
			title: 'Pensacola, FL',
			address: '125 West Romana Street, Suite 710',
			city: 'Pensacola',
			state: 'FL',
			zip: '32502',
			phone: '(850) 438-9914'
		} /*
		{
			id: 4,
			title: 'Orlando, FL',
			address: '13501 Ingenuity Drive, Suite 146',
			city: 'Orlando',
			state: 'FL',
			zip: '32826',
			phone: '(407) 802-4810'
		} */
	]
};



// WEBPACK FOOTER //
// ./src/data/About.js